import angular from 'angular';

Backend.$inject = ['Restangular', '$cacheFactory'];

export function Backend(Restangular, $cacheFactory) {
    return Restangular.withConfig(function(RestangularConfigurer) {
        // The URL of the API endpoint
        RestangularConfigurer.setBaseUrl(process.env.OMNIYOU_API);

        // JSON-LD @id support
        RestangularConfigurer.setRestangularFields({
            id: '@id',
            selfLink: '@id'
        });
        RestangularConfigurer.setSelfLinkAbsoluteUrl(false);

        // Hydra collections support
        RestangularConfigurer.addResponseInterceptor(function(data, operation) {
            // Remove trailing slash to make Restangular working
            function populateHref(data) {
                if (data['@id']) {
                    data.href = data['@id'].substring(1);
                }
            }

            // Populate href property for the collection
            populateHref(data);

            if ('getList' === operation) {
                var collectionResponse = data['hydra:member'];
                collectionResponse.metadata = {};

                // Put metadata in a property of the collection
                angular.forEach(data, function(value, key) {
                    if ('hydra:member' !== key) {
                        collectionResponse.metadata[key] = value;
                    }
                });

                // Populate href property for all elements of the collection
                angular.forEach(collectionResponse, function(value) {
                    populateHref(value);
                });

                return collectionResponse;
            }

            return data;
        });

        const cache = $cacheFactory('http');
        RestangularConfigurer.setDefaultHttpFields({cache: cache});

        RestangularConfigurer.addResponseInterceptor(function(response, operation) {
            if (operation === 'put' || operation === 'patch' || operation === 'post' || operation === 'remove') {
                cache.removeAll();
                console.log('cache cleared');
            }
            return response;
        })

        // RestangularConfigurer.setDefaultRequestParams('get', {
        //     langFallback: true
        // });
    });
}